export const FlagGBIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21_246)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M2.48069 4.69299C1.53808 5.91938 0.827311 7.3329 0.413452 8.86848H6.65617L2.48069 4.69299Z"
          fill="#0052B4"
        />
        <path
          d="M23.587 8.86864C23.1732 7.33311 22.4623 5.9196 21.5198 4.69321L17.3444 8.86864H23.587Z"
          fill="#0052B4"
        />
        <path
          d="M0.413452 15.1302C0.827359 16.6658 1.53812 18.0793 2.48069 19.3056L6.65603 15.1302H0.413452Z"
          fill="#0052B4"
        />
        <path
          d="M19.3055 2.47979C18.0792 1.53718 16.6657 0.826413 15.1301 0.412506V6.65518L19.3055 2.47979Z"
          fill="#0052B4"
        />
        <path
          d="M4.69395 21.5177C5.92035 22.4603 7.33386 23.1711 8.8694 23.585V17.3424L4.69395 21.5177Z"
          fill="#0052B4"
        />
        <path
          d="M8.86935 0.412506C7.33381 0.826412 5.9203 1.53718 4.69395 2.47974L8.86935 6.65513V0.412506Z"
          fill="#0052B4"
        />
        <path
          d="M15.1301 23.585C16.6656 23.1711 18.0792 22.4603 19.3055 21.5177L15.1301 17.3424V23.585Z"
          fill="#0052B4"
        />
        <path
          d="M17.3444 15.1302L21.5198 19.3057C22.4623 18.0793 23.1732 16.6658 23.587 15.1302H17.3444Z"
          fill="#0052B4"
        />
        <path
          d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
          fill="#D80027"
        />
        <path
          d="M15.1304 15.1313L20.4852 20.4861C20.7315 20.2399 20.9665 19.9825 21.1906 19.7157L16.6062 15.1312H15.1304V15.1313Z"
          fill="#D80027"
        />
        <path
          d="M8.86953 15.1312H8.86944L3.51467 20.486C3.76086 20.7323 4.01825 20.9672 4.28506 21.1913L8.86953 16.6068V15.1312Z"
          fill="#D80027"
        />
        <path
          d="M8.86938 8.86911V8.86902L3.51456 3.51416C3.26828 3.76035 3.03335 4.01774 2.80919 4.28455L7.3937 8.86907H8.86938V8.86911Z"
          fill="#D80027"
        />
        <path
          d="M15.1304 8.8702L20.4853 3.5153C20.2391 3.26901 19.9817 3.03408 19.7149 2.80997L15.1304 7.39448V8.8702Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_246">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
